import { EngineerEventBus } from "@/core/lib/engineer/engineer.lib";
import {
  GET,
  POST,
  PATCH,
  CLEAR_ERROR,
} from "@/core/services/store/request.module";

export default {
  data() {
    return {
      engineerCreated: false,
      engineerTab: "personal-info",
      pageLoading: false,
      updateEngineer: false,
      engineer: null,
      //  teamId: null,
      engineerArr: {},
      data: {
        title: "mr",
        first_name: null,
        color: null,
        profile_logo: null,
        last_name: null,
        skills: null,
        display_name: null,
        licensCertificate: [],
        skillCertificate: [],
        groupCertificates: [],
        start_licens_date: null,
        expire_licens_date: null,
        start_skill_date: null,
        expire_skill_date: null,
        primary_email: null,
        probation_start: null,

        wp_expired_date: null,
        fin_no: null,
        vehicle_no: null,
        iu_no: null,

        probation_end: null,
        probation_month_number: null,
        shift: null,
        is_team: false,
        ot_15_date: null,
        ot_2_date: null,
        probation_type: null,
        primary_phone: null,
        emergency_contact_name: null,
        emergency_contact_number: null,
        emergency_contact_relation: null,
        emergency_contact_unit_no: null,
        emergency_contact_street_1: null,
        emergency_contact_street_2: null,
        emergency_contact_postal_code: null,
        emergency_contact_email: null,
        address_line_1: null,
        address_line_2: null,
        unit_number: null,
        postal_code: null,
        country_name: null,
        emergency_country_name: null,
        country: null,
        state: null,
        city: null,
        leave: null,
        remarks: null,
        can_login: 1,
        ot_eligible: 1,
        is_tracking_enabled: 0,
        email_notification: 1,
        engineer_leaves: {},
        allow_leave: 0,
        is_driver: 0,
        designation: 0,
        department: 0,
        employee_code: null,
        support_admin: null,
        po_letter_code: null,
        role: 0,
        zone_territory: [],
        force_password_change: 1,
        retention_period: null,
        deletion_period: null,
        period: "Days",
      },
    };
  },
  methods: {
    getEngineer() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(GET, { url: "engineer/" + _this.engineer })
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },

    getTeamSingle() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(GET, { url: "team/" + _this.teamId })
            .then((response) => {
              // console.log(response,"response");
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    onSubmit() {
      const _this = this;
      if (!_this.$refs.engineerForm.validate()) {
        return false;
      }

      _this.formLoading = true;
      _this.$store.dispatch(CLEAR_ERROR, {});

      const certificates = this.$refs.groupCertificatesRef.groupCertificates;
      const leave = this.$refs.leaveRef?.groupLeaves || [];

      const formData = {
        title: _this.data.title,
        first_name: _this.data.first_name,
        color: _this.data.color,
        profile_logo: _this.data.profile_logo
          ? _this.data.profile_logo.id
          : null,
        last_name: _this.data.last_name,
        skills: _this.data.skills,
        display_name: _this.data.display_name,
        primary_email: _this.data.primary_email,
        probation_start: _this.data.probation_start,

        iu_no: _this.data.iu_no,
        wp_expired_date: _this.data.wp_expired_date,
        fin_no: _this.data.fin_no,
        vehicle_no: _this.data.vehicle_no,

        probation_end: _this.data.probation_end,
        probation_type: _this.data.probation_type,
        probation_month_number: _this.data.probation_month_number,
        shift: _this.data.shift,
        is_team: _this.data.is_team,
        ot_15_date: _this.data.ot_15_date,
        ot_2_date: _this.data.ot_2_date,
        primary_phone: _this.data.primary_phone,
        emergency_contact_name: _this.data.emergency_contact_name,
        emergency_contact_number: _this.data.emergency_contact_number,
        emergency_contact_relation: _this.data.emergency_contact_relation,
        emergency_contact_email: _this.data.emergency_contact_email,
        emergency_contact_unit_no: _this.data.emergency_contact_unit_no,
        emergency_contact_street_1: _this.data.emergency_contact_street_1,
        emergency_contact_street_2: _this.data.emergency_contact_street_2,
        emergency_contact_postal_code: _this.data.emergency_contact_postal_code,
        licensCertificate: _this.data.licensCertificate,
        skillCertificate: _this.data.skillCertificate,
        groupCertificates: certificates,
        //groupCertificates:'sdfasdfas',
        start_licens_date: _this.data.start_licens_date,
        expire_licens_date: _this.data.expire_licens_date,
        start_skill_date: _this.data.start_skill_date,
        expire_skill_date: _this.data.expire_skill_date,
        address_line_1: _this.data.address_line_1,
        address_line_2: _this.data.address_line_2,
        unit_number: _this.data.unit_number,
        postal_code: _this.data.postal_code,
        country_name: _this.data.country_name,
        emergency_country_name: _this.data.emergency_country_name,
        country: _this.data.country,
        state: _this.data.state,
        city: _this.data.city,
        leave: _this.data.leave,
        allow_leave: _this.data.allow_leave,
        is_driver: _this.data.is_driver,
        engineer_leaves: leave,
        remarks: _this.data.remarks,
        can_login: _this.data.can_login,
        ot_eligible: _this.data.ot_eligible,
        is_tracking_enabled: _this.data.is_tracking_enabled,
        email_notification: _this.data.email_notification,
        designation: _this.data.designation,
        department: _this.data.department,
        employee_code: _this.data.employee_code,
        support_admin: _this.data.support_admin,
        po_letter_code: _this.data.po_letter_code,
        role: _this.data.role,
        zone_territory: _this.data.zone_territory,
        force_password_change: _this.data?.force_password_change,
        retention_period: _this.data?.retention_period,
        deletion_period: _this.data?.deletion_period,
        period: _this.data?.period,
      };
      //console.log(formData,"formData");
      let REQUEST_TYPE = POST;
      let REQUEST_URL = "engineer";
      if (
        _this.$route.name == "admin.engineer.update" ||
        _this.$route.name == "engineer.engineer.update"
      ) {
        REQUEST_TYPE = PATCH;
        REQUEST_URL = "engineer/" + _this.$route.params.id;
      }

      _this.$store
        .dispatch(REQUEST_TYPE, { url: REQUEST_URL, data: formData })
        .then((response) => {
          _this.engineerCreated = true;
          _this.engineer = response.data.id;
          _this.engineerArr = response.data;
          _this.$router.replace(
            _this.getDefaultRoute("engineer.detail", {
              params: { id: _this.engineer },
            })
          );
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.formLoading = false;
        });
    },
  },
  beforeDestroy() {
    /*EngineerEventBus.$off("update:personal-info");
    EngineerEventBus.$off("update:emergency-contact");
    EngineerEventBus.$off("update:address");
    EngineerEventBus.$off("update:color");*/
  },
  created() {
    const _this = this;
    EngineerEventBus.$on("update:personal-info", (argument) => {
      _this.data.profile_logo = argument.profile_image;
      _this.data.title = argument.title || "mr";
      _this.data.first_name = argument.first_name;
      _this.data.last_name = argument.last_name;
      _this.data.skills = argument.skills;
      /*   _this.data.licensCertificate = argument.licensCertificate,
      _this.data.skillCertificate = argument.skillCertificate,
      _this.data.start_licens_date = argument.start_licens_date,
      _this.data.expire_licens_date = argument.expire_licens_date,
      _this.data.start_skill_date = argument.start_skill_date,
      _this.data.expire_skill_date = argument.expire_skill_date, */
      _this.data.role = argument.role;
      _this.data.display_name = argument.display_name;
      _this.data.designation = argument.designation;
      _this.data.department = argument.department;
      _this.data.employee_code = argument.employee_code;
      _this.data.support_admin = argument.support_admin;
      _this.data.po_letter_code = argument.po_letter_code;
      _this.data.primary_email = argument.primary_email;
      _this.data.probation_start = argument.probation_start;

      (_this.data.iu_no = argument.iu_no),
        (_this.data.wp_expired_date = argument.wp_expired_date),
        (_this.data.fin_no = argument.fin_no),
        (_this.data.vehicle_no = argument.vehicle_no),
        (_this.data.probation_end = argument.probation_end);
      _this.data.probation_type = argument.probation_type;
      _this.data.shift = argument.shift;
      _this.data.is_team =
        argument.is_team === true ||
        argument.is_team === 1 ||
        argument.is_team === "1"
          ? 1
          : 0;
      _this.data.ot_15_date = argument.ot_15_date;
      _this.data.ot_2_date = argument.ot_2_date;
      _this.data.probation_month_number = argument.probation_month_number;
      _this.data.primary_phone = argument.primary_phone;
      _this.data.engineer_leaves = argument.engineerLeaves;
      _this.data.allow_leave = argument.allow_leave;
      _this.data.is_driver = argument.is_driver;
      _this.data.leave = argument.leave;
      _this.data.zone_territory = argument.zone_territory;
      _this.data.force_password_change = argument?.force_password_change;
      _this.data.retention_period = argument?.retention_period;
      _this.data.deletion_period = argument?.deletion_period;
      _this.data.period = argument?.period;
      _this.data.can_login =
        _this.lodash.toSafeInteger(argument.can_login) || 0;
      _this.data.email_notification =
        _this.lodash.toSafeInteger(argument.email_notification) || 0;
      _this.data.ot_eligible =
        _this.lodash.toSafeInteger(argument.ot_eligible) || 0;
      _this.data.is_tracking_enabled =
        _this.lodash.toSafeInteger(argument.is_tracking_enabled) || 0;
    });

    EngineerEventBus.$on("update:emergency-contact", (argument) => {
      _this.data.emergency_contact_name = argument.name;
      _this.data.emergency_contact_number = argument.mobile;
      _this.data.emergency_contact_relation = argument.relation;
      _this.data.emergency_contact_email = argument.email;
      _this.data.emergency_contact_unit_no = argument.unit_no;
      _this.data.emergency_contact_street_1 = argument.street_1;
      _this.data.emergency_contact_street_2 = argument.street_2;
      _this.data.emergency_contact_postal_code = argument.postal_code;
      _this.data.emergency_country_name = argument.emergency_country_name;
    });
    EngineerEventBus.$on("update:skill-licence", (argument) => {
      _this.data.skillCertificate = argument.skillCertificate;
      _this.data.licensCertificate = argument.licensCertificate;
      _this.data.start_skill_date = argument.start_skill_date;
      _this.data.expire_skill_date = argument.expire_skill_date;
      _this.data.start_licens_date = argument.start_licens_date;
      _this.data.expire_licens_date = argument.expire_licens_date;
    });
    EngineerEventBus.$on("update:engineer-leaves", (argument) => {
      _this.data.engineer_leaves = argument;
    });
    EngineerEventBus.$on("update:group-certificates", (argument) => {
      //  console.log(argument,"argument");
      _this.data.groupCertificates = argument.groupCertificates;
      // _this.data.type = argument.type;
      // _this.data.related_value = argument.related_value;
      // _this.data.start_date = argument.start_date;
      // _this.data.expire_date = argument.expire_date;
      // _this.data.reminder_date = argument.reminder_date;
    });

    EngineerEventBus.$on("update:address", (argument) => {
      _this.data.address_line_1 = argument.street_1;
      _this.data.address_line_2 = argument.street_2;
      _this.data.unit_number = argument.unit_no;
      _this.data.postal_code = argument.postal_code;
      _this.data.country_name = argument.country_name;
      _this.data.country = _this.lodash.toSafeInteger(argument.country) || null;
      _this.data.state = _this.lodash.toSafeInteger(argument.state) || null;
      _this.data.city = _this.lodash.toSafeInteger(argument.city) || null;
    });

    EngineerEventBus.$on("update:color", (argument) => {
      _this.data.color = argument.hexa;
    });
  },
};
